<div class="ImageCropper">
    <div class="text-center ImageCropper__buttons flex flex-col sm:flex-row gap-5 justify-center items-center">
        <div class="ImageCropper__fileWrapper position-relative">
            <button mat-raised-button color="accent" (click)="onOpenModal()">
                <mat-icon>file_upload</mat-icon>{{ "chooseFile" | translate }}
            </button>
            <input type="file" (change)="fileChangeEvent($event)" accept="image/png, image/gif, image/jpeg, image/svg" class="position-absolute"/>
        </div>
        <button type="button" mat-raised-button color="accent" (click)="resetImage()"
            style="min-width: 150px;"><mat-icon>360</mat-icon>{{ "resetImage" | translate }}</button>
    </div>

    <!-- Cropper UI lives in a dialog so it always fits the screen -->
    <ng-template #cropperDialog>
        <div class="ImageCropperDialog">
            <div class="ImageCropperDialog__head">
                <span class="ImageCropperDialog__title">{{ "chooseFile" | translate }}</span>
                <button mat-icon-button type="button" (click)="cancelCrop()" aria-label="Close">
                    <mat-icon>close</mat-icon>
                </button>
            </div>

            <div class="flex gap-5 justify-center items-center mb-15">
                <button type="button" mat-mini-fab color="white" (click)="rotateLeft()">
                    <mat-icon class="m-0">rotate_left</mat-icon>
                </button>
                <button type="button" mat-mini-fab color="white" (click)="rotateRight()">
                    <mat-icon class="m-0">rotate_right</mat-icon>
                </button>
                <button type="button" mat-mini-fab color="white" (click)="flipHorizontal()">
                    <mat-icon class="m-0">swap_horiz</mat-icon>
                </button>
                <button type="button" mat-mini-fab color="white" (click)="flipVertical()">
                    <mat-icon class="m-0">swap_horizontal_circle</mat-icon>
                </button>
            </div>

            <div class="ImageCropperDialog__canvas">
                <image-cropper [imageChangedEvent]="imageChangedEvent" [maintainAspectRatio]="maintainAspectRatio"
                    [containWithinAspectRatio]="containWithinAspectRatio" [aspectRatio]="aspectRatio"
                    [resizeToWidth]="resizeToWidth" [format]="'png'" [imageQuality]="100" [cropperMinWidth]="75"
                    [cropperMinHeight]="75" [onlyScaleDown]="true" [roundCropper]="false" [transform]="transform"
                    [canvasRotation]="canvasRotation" [backgroundColor]="bgColor" [alignImage]="'center'"
                    (imageCropped)="imageCropped($event)" (imageLoaded)="imageLoaded()" (cropperReady)="cropperReady()"
                    (loadImageFailed)="loadImageFailed()"></image-cropper>
            </div>

            <div class="flex gap-5 justify-center items-center mt-15">
                <button type="button" mat-raised-button color="white" style="min-width: 200px;"
                    (click)="toggleContainWithinAspectRatio()">
                    <span *ngIf="containWithinAspectRatio; else fillBlock">
                        {{ "containAspect" | translate }}
                    </span>
                    <ng-template #fillBlock>{{ 'fillAspect' | translate }}</ng-template>
                </button>
                <button type="button" mat-raised-button color="primary" (click)="onSubmit()">{{ "saveImage" | translate }}</button>
            </div>
        </div>
    </ng-template>
</div>
